var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentDialog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3587_29990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 0C11.733 0 3 8.25334 3 19.3991C3 25.2314 5.39074 30.2698 9.28259 33.7494C9.60919 34.044 9.80567 34.4496 9.82065 34.8896L9.92932 38.4463C9.96573 39.582 11.1376 40.3183 12.1749 39.8638L16.1434 38.1133C16.4809 37.9638 16.8565 37.9362 17.2087 38.032C19.0317 38.536 20.9762 38.8006 23.0001 38.8006C34.267 38.8006 43 30.5473 43 19.3992C43 8.25341 34.267 7.52179e-05 23.0001 7.52179e-05L22.9999 0Z",
    fill: "#E95B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61748 33.3781L9.61585 33.3767C5.83009 29.9919 3.5 25.0891 3.5 19.3991C3.5 8.56653 11.961 0.528424 22.9416 0.500075H23.0001C34.0091 0.500075 42.5 8.54744 42.5 19.3992C42.5 30.2533 34.009 38.3006 23.0001 38.3006C21.0198 38.3006 19.1202 38.0417 17.3419 37.55L17.3399 37.5495C16.8771 37.4236 16.3836 37.4601 15.9409 37.6562L11.9743 39.4058C11.974 39.4059 11.9738 39.406 11.9736 39.4061C11.26 39.7182 10.4544 39.2117 10.4291 38.4307C10.4291 38.4306 10.4291 38.4304 10.4291 38.4303L10.3204 34.8743L10.3204 34.8726C10.3006 34.2912 10.0404 33.7596 9.61748 33.3781Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3587_29990",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3587_29990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3587_29990",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDialog);
export default __webpack_public_path__ + "static/media/CommentDialog.2ee397c9ae953e4029d27561e0b76363.svg";
export { ForwardRef as ReactComponent };